import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapeSummingJunction extends Shape {
    needFill = false;
    defaultColor = "transparent";
    includeText = false;

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.ellipse(
            x + width / 2,
            y + height / 2,
            height / 2,
            width / 2,
            Math.PI / 2,
            0,
            2 * Math.PI,
        );

        const { bottomLeft, topRight, bottomRight, topLeft } = getEllipsePoints(
            x + width / 2,
            y + height / 2,
            width / 2,
            height / 2,
            width,
            height,
        );

        canv.ctx.moveTo(bottomLeft.x, bottomLeft.y);
        canv.ctx.lineTo(topRight.x, topRight.y);

        canv.ctx.moveTo(bottomRight.x, bottomRight.y);
        canv.ctx.lineTo(topLeft.x, topLeft.y);
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" stroke-linejoin="round" d="M4.7 4.44a10.47 10.47 0 0 0-.2 14.9m.2-14.9a10.47 10.47 0 0 1 14.66.07M4.71 4.44 19.36 19.5m0 0a10.47 10.47 0 0 0 0-14.98m0 14.98a10.47 10.47 0 0 1-14.86-.15m0 0L19.36 4.51"/>
            </svg>
        `;
    }
}

type Points = {
    right: { x: number; y: number };
    bottomRight: { x: number; y: number };
    bottom: { x: number; y: number };
    bottomLeft: { x: number; y: number };
    left: { x: number; y: number };
    topLeft: { x: number; y: number };
    top: { x: number; y: number };
    topRight: { x: number; y: number };
};

function getEllipsePoints(
    cx: number,
    cy: number,
    rx: number,
    ry: number,
    width: number,
    height: number,
) {
    const points: Points = {
        right: { x: 0, y: 0 },
        bottomRight: { x: 0, y: 0 },
        bottom: { x: 0, y: 0 },
        bottomLeft: { x: 0, y: 0 },
        left: { x: 0, y: 0 },
        topLeft: { x: 0, y: 0 },
        top: { x: 0, y: 0 },
        topRight: { x: 0, y: 0 },
    };
    const directions = [
        { name: "right", angle: 0 },
        { name: "bottomRight", angle: 90 - getDiagonalAngle(width, height) },
        { name: "bottom", angle: 90 },
        { name: "bottomLeft", angle: 90 + getDiagonalAngle(width, height) },
        { name: "left", angle: 180 },
        { name: "topLeft", angle: 180 + (90 - getDiagonalAngle(width, height)) },
        { name: "top", angle: 270 },
        { name: "topRight", angle: 270 + getDiagonalAngle(width, height) },
    ];

    directions.forEach((dir) => {
        const angleRad = dir.angle * (Math.PI / 180);
        const dirX = Math.cos(angleRad);
        const dirY = Math.sin(angleRad);

        const t = Math.atan2(ry * dirY, rx * dirX);

        const x = cx + rx * Math.cos(t);
        const y = cy + ry * Math.sin(t);

        points[dir.name] = { x, y };
    });

    return points;
}

function getDiagonalAngle(width: number, height: number) {
    const angleRad = Math.atan2(height, width);

    return angleRad * (180 / Math.PI);
}
